import {BasePqmFieldValue} from "./BasePqmFieldValue";
import {PqmFieldRegister} from "./PqmFieldRegister";
import {getSelectedValue, setSelectedValue} from "../../Utils";
import {PqmPacket, PqmProcData} from "../pqmTypes";
import {UiRadioList} from "../../components/UiRadioList";
import {TreeSelector} from "../../TreeSelector";
import {UiTomSelect} from "../../components/UiTomSelect";
import {MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {UiChboxList} from "../../components/UiChboxList";

export class PqmFieldSet extends BasePqmFieldValue {
	static getValueTypes(): string[] {
		return [ "set:*" ];
	}

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		value:UiChboxList|UiTomSelect,
	}>;

	beforeIndex() {
		// @ts-ignore
		this.muAppendContent({
			chboxList: `<div mu="value:UiChboxList#value" class="radiolist-vertical"></div>`,
			tags: `<div mu="value:UiTomSelect#value" class="radiolist-horizontal" mu-params='{"multiple":true}'></div>`,
		}[this.control]);
	}

	afterIndex() {
		if (this.numberingId) {
			const numberingValues = (this.getPropertyInAncestors('pqmProcData') as PqmProcData).numberingValues[this.numberingId];
			switch (this.control) {
				case 'chboxList':
				case 'chboxListHorizontal':
					(this.muNamedWidget.value as unknown as UiRadioList).bindItems(
						numberingValues.map(nv => ({ id: nv.id.toString(), title: nv.name }))
					);
					break;
				case 'tags':
					(this.muNamedWidget.value as unknown as UiTomSelect).bindItems(numberingValues);
					break;
			}
		}
	}
	isFilled(): boolean {
		const v = this.getValue();
		return v && v.length > 0;
	}

	setDisabled(disabled: boolean) {
		this.muNamedWidget.value.setDisabled(disabled);
	}
}

// @ts-ignore
PqmFieldRegister.register(PqmFieldSet);